import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Typography,
  Container,
  LinearProgress,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { uploadAllDummyData } from '../utils/firestoreUpload';

export default function UploadDataDebug() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('idle'); // idle, success, error
  const [message, setMessage] = useState('');
  const [progress, setProgress] = useState('');

  const handleUpload = async () => {
    setLoading(true);
    setStatus('idle');
    setMessage('');
    setProgress('Starting upload...');
    
    try {
      console.log('🚀 Starting dummy data upload to Firestore...');
      setProgress('Uploading teachers...');
      
      await uploadAllDummyData('inst_test_college_001');
      
      setStatus('success');
      setMessage('✅ All dummy data uploaded successfully! You can now:');
      setProgress('');
      console.log('✅ Upload completed successfully');
      
    } catch (error) {
      console.error('❌ Upload error:', error);
      setStatus('error');
      setMessage(`❌ Upload failed: ${error.message}`);
      setProgress('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Card>
        <CardContent sx={{ textAlign: 'center' }}>
          <Box sx={{ mb: 3 }}>
            <CloudUploadIcon sx={{ fontSize: 64, color: 'primary.main' }} />
          </Box>

          <Typography variant="h4" gutterBottom>
            Upload Dummy Data to Firestore
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            This will populate Firestore with test data for admin, teachers, and students.
          </Typography>

          {status === 'success' && (
            <Alert 
              icon={<CheckCircleIcon fontSize="inherit" />}
              severity="success" 
              sx={{ mb: 2, textAlign: 'left' }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                ✅ All dummy data uploaded successfully!
              </Typography>
              <Typography variant="body2">
                You can now login with:
              </Typography>
              <Typography variant="body2" component="div" sx={{ mt: 1, pl: 1 }}>
                <strong>Admin:</strong> admin@testcollege.com / AdminPassword@123
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 1 }}>
                <strong>Teacher:</strong> ahmed.khan@testcollege.com / TPassword@123
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 1 }}>
                <strong>Student:</strong> ali.hassan@student.com / SPassword@123
              </Typography>
            </Alert>
          )}

          {status === 'error' && (
            <Alert 
              icon={<ErrorIcon fontSize="inherit" />}
              severity="error" 
              sx={{ mb: 2, textAlign: 'left' }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {message}
              </Typography>
              <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                Check the browser console (F12) for more details.
              </Typography>
            </Alert>
          )}

          {progress && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {progress}
              </Typography>
              <LinearProgress />
            </Box>
          )}

          <Button
            variant="contained"
            size="large"
            onClick={handleUpload}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <CloudUploadIcon />}
            sx={{ mt: 2, minWidth: 200 }}
          >
            {loading ? 'Uploading...' : 'Upload Dummy Data'}
          </Button>

          <Box sx={{ mt: 4, p: 2, bgcolor: '#f5f5f5', borderRadius: 1, textAlign: 'left' }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
              📋 What will be uploaded:
            </Typography>
            <Typography variant="body2" component="div" sx={{ pl: 1 }}>
              ✓ 4 Teachers<br/>
              ✓ 8 Students<br/>
              ✓ 2 Classes<br/>
              ✓ 8 Subjects (with semesters)<br/>
              ✓ 2 Admin/Principal users<br/>
              ✓ Assignments, attendance, marks, and submissions
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
